import {
    FolderKanban,
    Activity,
    IndianRupee,
    AlertTriangle,
} from "lucide-react";
import RevenueChart from "./RevenueChart";
import CategoryChart from "./CategoryChart";
import UtilizationChart from "./UtilizationChart";
import LiveActivity from "./LiveActivity";

const stats = [
    {
        title: "TOTAL PROJECTS",
        value: "486",
        change: "+12%",
        trend: "up",
        color: "bg-indigo-100 text-indigo-600",
        icon: FolderKanban,
    },
    {
        title: "ACTIVE PROJECTS",
        value: "142",
        change: "+8",
        trend: "up",
        color: "bg-cyan-100 text-cyan-600",
        icon: Activity,
    },
    {
        title: "MACHINE UTILIZATION",
        value: "78%",
        change: "+4%",
        trend: "up",
        color: "bg-green-100 text-green-600",
        icon: Activity,
    },
    {
        title: "REVENUE (NOV)",
        value: "₹92L",
        change: "+10%",
        trend: "up",
        color: "bg-purple-100 text-purple-600",
        icon: IndianRupee,
    },
    {
        title: "PENDING PAYMENTS",
        value: "₹14L",
        change: "6 invoices",
        trend: "warning",
        color: "bg-orange-100 text-orange-500",
        icon: AlertTriangle,
    },
    {
        title: "INVENTORY ALERTS",
        value: "9",
        change: "3 Critical",
        trend: "warning",
        color: "bg-red-100 text-red-500",
        icon: AlertTriangle,
    },
];

export default function DashboardHome() {
    return (
        <main className="flex-1 bg-slate-50 p-8 overflow-auto">
            {/* Heading */}
            <div className="mb-8">
                <h1 className="text-4xl font-bold text-slate-900 tracking-tight">
                    Operations Command Centre
                </h1>
                <p className="text-slate-500 mt-2 text-base">
                    Real-time overview across your APIC centre
                </p>
            </div>

            {/* Stat Cards */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-4">
                {stats.map((item, index) => (
                    <div
                        key={index}
                        className="bg-white rounded-2xl border border-slate-200 px-5 py-4 shadow-sm hover:shadow-md hover:-translate-y-1 transition-all duration-300"
                    >
                        {/* Header */}
                        <div className="flex justify-between items-start">
                            <div>
                                <p className="text-[10px] uppercase tracking-[1.5px] font-semibold text-slate-500">
                                    {item.title}
                                </p>
                                <h2 className="text-2xl font-bold text-slate-900 mt-2">
                                    {item.value}
                                </h2>
                            </div>

                            <div
                                className={`w-9 h-9 rounded-lg flex items-center justify-center shrink-0 ${item.color}`}
                            >
                                <item.icon size={16} />
                            </div>
                        </div>

                        {/* Footer */}
                        <div className="flex items-center justify-between mt-4">
                            <span
                                className={`text-xs font-medium flex items-center gap-1 ${item.trend === "up"
                                    ? "text-green-600"
                                    : "text-orange-500"
                                    }`}
                            >
                                {item.trend === "up" ? "↗" : "⚠"}
                                {item.change}
                            </span>

                            <span className="text-[10px] text-slate-400">
                                This Month
                            </span>
                        </div>
                    </div>
                ))}
            </div>

            {/* Charts */}
            <div className="grid grid-cols-12 gap-6 mt-8">
                {/* Revenue */}
                <div className="col-span-12 xl:col-span-8 bg-white rounded-3xl border border-slate-200 shadow-sm">
                    <div className="flex justify-between items-center p-6 border-b border-slate-100">
                        <div>
                            <h2 className="text-xl font-bold text-slate-900">
                                Revenue & Projects
                            </h2>
                            <p className="text-slate-500 text-sm mt-0.5">
                                Monthly performance
                            </p>
                        </div>

                        <button className="border border-slate-200 rounded-full px-4 py-1.5 text-sm font-semibold text-slate-600 hover:bg-slate-50 transition-colors">
                            FY 2025-26
                        </button>
                    </div>

                    <div className="h-[420px] px-5 pb-5 pt-2">
                        <RevenueChart />
                    </div>
                </div>

                {/* Category */}
                <div className="col-span-12 xl:col-span-4 bg-white rounded-3xl border border-slate-200 shadow-sm">
                    <div className="p-6 border-b border-slate-100">
                        <h2 className="text-xl font-bold text-slate-900">
                            Prototype Categories
                        </h2>
                        <p className="text-slate-500 text-sm mt-0.5">
                            Distribution this quarter
                        </p>
                    </div>

                    <div className="h-[420px]">
                        <CategoryChart />
                    </div>
                </div>
            </div>

            {/* Utilization + Live Activity */}
            <div className="grid grid-cols-12 gap-6 mt-6">
                {/* Centre-wise utilization */}
                <div className="col-span-12 xl:col-span-8 bg-white rounded-3xl border border-slate-200 shadow-sm">
                    <div className="p-6 border-b border-slate-100">
                        <h2 className="text-xl font-bold text-slate-900">
                            Centre-wise Machine Utilization
                        </h2>
                    </div>

                    <div className="h-[340px] px-5 pb-5 pt-2">
                        <UtilizationChart />
                    </div>
                </div>

                {/* Live Activity */}
                <div className="col-span-12 xl:col-span-4 bg-white rounded-3xl border border-slate-200 shadow-sm">
                    <div className="flex items-center justify-between p-6 border-b border-slate-100">
                        <h2 className="text-xl font-bold text-slate-900">
                            Live Activity
                        </h2>

                        <span className="flex items-center gap-1.5 text-xs font-semibold text-green-600">
                            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse" />
                            LIVE
                        </span>
                    </div>

                    <LiveActivity />
                </div>
            </div>
        </main>
    );
}